// extracted by mini-css-extract-plugin
export default {"text":"ScoreDatail_text__t0+Sq","table":"ScoreDatail_table__3ldUo"};